import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import FindInPageOutlinedIcon from "@mui/icons-material/FindInPageOutlined";

const RolloverEmptyState = ({ currentYearOfAssessment }) => (
  <Paper variant='outlined' sx={{ borderRadius: 2, bgcolor: "action.hover" }}>
    <Stack
      role='status'
      alignItems='center'
      spacing={2}
      sx={{ px: 3, py: 5, textAlign: "center" }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 64,
          height: 64,
          borderRadius: 2,
          color: "primary.main",
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
        }}
      >
        <FindInPageOutlinedIcon sx={{ fontSize: 32 }} />
      </Box>
      <Stack spacing={1} sx={{ maxWidth: 380 }}>
        <Typography variant='subtitle1' fontWeight={600}>
          No previous year computations
        </Typography>
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{ lineHeight: 1.7 }}
        >
          There are no tax computations for this company before YA{" "}
          {currentYearOfAssessment} to roll over from.
        </Typography>
        <Typography
          variant='caption'
          color='text.secondary'
          sx={{ lineHeight: 1.6 }}
        >
          An earlier year’s computation will appear here once it is available.
        </Typography>
      </Stack>
    </Stack>
  </Paper>
);

export default RolloverEmptyState;
